import {
  FETCH_RFID,
  FETCH_RFID_SUCCESS,
  FETCH_RFID_FAIL,
  GET_RFID,
  GET_RFID_SUCCESS,
  GET_RFID_FAIL,
  CREATE_RFID,
  CREATE_RFID_SUCCESS,
  CREATE_RFID_FAIL,
  UPDATE_RFID,
  UPDATE_RFID_FAIL,
  UPDATE_RFID_SUCCESS,
  DELETE_RFID,
  DELETE_RFID_SUCCESS,
  DELETE_RFID_FAIL,
} from 'actions/rfid';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  rfid: [],
  rfidDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const rfidReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_RFID:
    case GET_RFID:
    case CREATE_RFID:
    case DELETE_RFID: {
      return { ...state, isLoading: true, rfidDetail: {} };
    }

    case UPDATE_RFID: {
      return { ...state, isLoading: true };
    }

    case FETCH_RFID_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        rfid: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_RFID_SUCCESS: {
      return {
        ...state,
        rfidDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_RFID_SUCCESS: {
      toast.success('RFID added successfully');
      return {
        ...state,
        rfid: _.concat(state.rfid, payload),
        isLoading: false,
      };
    }

    case UPDATE_RFID_SUCCESS: {
      toast.success('RFID updated successfully');
      return {
        ...state,
        isLoading: false,
        rfid: state.rfid.map((data) => {
          if (data.id === payload.id) {
            return payload;
          } else {
            return data;
          }
        }),
      };
    }

    case DELETE_RFID_SUCCESS: {
      toast.success('RFID deleted successfully');
      return {
        ...state,
        isLoading: false,
        rfid: state.rfid.filter((data) => data.id !== payload),
      };
    }

    case FETCH_RFID_FAIL:
    case GET_RFID_FAIL:
    case CREATE_RFID_FAIL:
    case UPDATE_RFID_FAIL:
    case DELETE_RFID_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default rfidReducer;
